<script>
export default {
  name: "EmployeeModal",
  props: {
    altId: {
      type: String,
      default: "externalEmployee-modal",
    },
  },
  data() {
    return {
      submitted: false,
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 25, 50, 100],
      searchFilter: "",
      filterOn: [],
      sortBy: "employee",
      sortDesc: false,
      fields: [
        {
          key: "employee",
          sortable: true,
          label: "Employee",
          thStyle: { width: "85%" },
        },
      ],
      indexSelected: -1,
      tableBusy: false,
      multiple: false,
      selectedCampus: this.$store.state.data.selectedCampus.id,
      selectedDU: this.$store.state.data.selectedDU.id,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      searchData: [],
      searchDU: false,
    };
  },
  computed: {
    rows() {
      if (this.searchFilter && this.searchFilter.length > 0) {
        return this.totalRows;
      }
      return this.tableData.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    dropData(data) {
      this.$emit("dropData", data[0]);
      this.$bvModal.hide("externalEmployee-modal");
    },
    resetData(filter) {
      this.tableData = [];
      this.searchDU = false;
      if (!filter) this.searchFilter = "";
      else {
        this.searchFilter = filter;
        this.searchAllData();
      }
      this.searchFilter = "";
    },
    async getDuEmployee() {
      this.tableData = [];
      this.tableBusy = true;
      this.searchDU = true;
      this.searchFilter = "";
      this.selectedDU = this.$store.state.data.selectedDU.id;
      await this.$store
        .dispatch("externalemployee/GetEmployeeByDu", this.selectedDU)
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      this.tableBusy = false;
    },
    searchAllData() {
      if (this.searchFilter.length > 0) {
        this.tableBusy = true;
        var firstName = "";
        var lastName = this.searchFilter.trim();
        this.$store
          .dispatch("externalemployee/GetBySearch", { firstName, lastName })
          .then((res) => {
            if (res.data.length == 0)
              this.showToast(
                `There are no employees matching ${lastName}.`,
                "warning"
              );
            this.tableData = res.data;
          })
          .catch(() => {
            this.showToast("Something went wrong!", "error");
          });
        this.tableBusy = false;
      } else {
        this.tableData = [];
      }
    },
  },
};
</script>

<template>
  <b-modal
    :id="altId"
    title="Employee List"
    size="lg"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <div class="row mt-1">
      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div
          id="tickets-table_filter"
          class="dataTables_filter"
          v-if="searchDU"
        >
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              autocomplete="off"
              v-model="searchFilter"
              type="search"
              placeholder="Search..."
              class="form-control mx-2 w-75"
            ></b-form-input>
            <b-form-select
              class="form-select w-25"
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </label>
        </div>
        <div id="tickets-table_filter" class="dataTables_filter" v-else>
          <form @submit.prevent="searchAllData()">
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                autocomplete="off"
                v-model="searchFilter"
                type="search"
                placeholder="Search Lastname..."
                class="form-control mx-2 w-75"
              ></b-form-input>
              <b-form-select
                class="form-select w-25"
                v-model="perPage"
                :options="pageOptions"
              ></b-form-select>
            </label>
          </form>
        </div>
      </div>
      <!-- End search -->
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="tableData"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="searchFilter"
        :filter-included-fields="filterOn"
        :busy="tableBusy"
        @filtered="onFiltered"
        bordered
        outlined
        hover
        striped
        show-empty
        :select-mode="multiple ? 'range' : 'single'"
        selectable
        @row-selected="dropData"
      >
        <template #empty="scope">
          <div class="text-center" v-if="searchDU">{{ scope.emptyText }}</div>
          <div class="text-center text-warning" v-else>
            Kindly type the lastname in the search input and then hit enter.
          </div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(employee)="row">
          <div class="d-flex align-items-center">
            <div>
              <div class="mt-1">
                <h5 class="mb-0">
                  {{
                    row.item.lastName.charAt(0).toUpperCase() +
                    row.item.lastName.slice(1)
                  }},
                  {{
                    row.item.firstName.charAt(0).toUpperCase() +
                    row.item.firstName.slice(1)
                  }}
                  {{
                    row.item.middleName
                      ? `${row.item.middleName.charAt(0).toUpperCase()}.`
                      : ""
                  }}
                </h5>
              </div>
              <div>ID No. {{ row.item.idNo }}</div>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>
